/**
 * --bq-sb-right: scrollbar width along the right edge, inside the containing
 * block of fixed elements (.page-wrapper's from 990px, otherwise 0). The Nuwa
 * and back-to-top launchers offset by it. Loaded synchronously from its body
 * position: the value must be set before they first paint, or they jump.
 */
(function () {
  var pw = document.querySelector('.page-wrapper');
  var sq = window.matchMedia('(min-width: 990px)');
  function set() {
    var sb = (pw && sq.matches) ? (pw.offsetWidth - pw.clientWidth) : 0;
    document.documentElement.style.setProperty('--bq-sb-right', sb + 'px');
  }
  set();
  window.addEventListener('resize', set, { passive: true });
  sq.addEventListener('change', set);
})();
